import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Empty, Grid, Modal, Skeleton, Space, Switch, Table, TablePaginationConfig, Tooltip } from 'antd';
import { SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import {
    EventsResponse,
    // useUpdateEvent,
} from 'features/events';
import { useStatusResponse } from 'features/shop-item/use-cases/update-status-response-msg';
import { usePermissions } from 'features/users';
import { Dispatch, SetStateAction, useState } from 'react';
import { Event } from 'types/event';

import { ManagementFilterFormPaginated } from '../type';
import { AddSizeModal } from './Add-size-modal/add-size-modal';


const { useBreakpoint } = Grid;

type EventsTableProps = {
    isLoading: boolean;
    data?: EventsResponse;
    tableParams: ManagementFilterFormPaginated;
    updateParams: Dispatch<SetStateAction<ManagementFilterFormPaginated>>;
    refetch: () => void;
    sizeEditData: any;
    setSizeEditData: any;
};

export const SizeTabel = ({
    data,
    isLoading,
    tableParams,
    updateParams,
    refetch,
    sizeEditData,
    setSizeEditData
}: EventsTableProps) => {
    const screens = useBreakpoint();
    const permissions = usePermissions();

    const { mutate: mutateUpdate, isLoading: isLoadingUpdate } =
        useStatusResponse();

    const { confirm } = Modal;

    const handleDelete = async (id: string) => {
        mutateUpdate({
            id: id,
            flag: "SIZE_MASTER_DELETE",
            status: true
        });
    }

    const handleTableChange = (
        pagination: TablePaginationConfig,
        // filters: Record<string, FilterValue | null>,
        sorter: SorterResult<Event> | SorterResult<Event>[],
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };

    const [showSizeModal, setShowSizeModal] = useState(false);

    if (!permissions) return null;

    const handleCloseModal = () => {
        setShowSizeModal(false);
        setSizeEditData(undefined);
        document.body.style.overflow = 'visible';
    }

    const handleOpenModal = (record: any) => {
        setShowSizeModal(true);
        setSizeEditData(record);
        document.body.style.overflow = 'hidden';
    }

    const showDeleteConfirm = (record: any) => {
        confirm({
            title: 'Are you sure you want to delete this Size?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                handleDelete(record.id);
            },
        });
    };

    return (
        <>
            <div className={`cstmrightmdl ${showSizeModal && "show"}`}>

                <AddSizeModal showSizeModal={showSizeModal} refetch={refetch} onClose={handleCloseModal} sizeEditData={sizeEditData} />
            </div>


            <StyledTableWrapper>
                <StyledTableHeader>
                    <RecordCountBadge
                        text={"Size found"}
                        count={data?.total || 0}
                    />
                </StyledTableHeader>
                <Table<Event>

                    className="cstltblwthldr"
                    locale={{
                        emptyText: isLoading ? <Skeleton active={true} /> : <Empty />
                    }}
                    loading={isLoading && { indicator: <div><TableLoader /></div> }}
                    dataSource={isLoading ? [] : data?.items}


                    rowKey='id'
                    onChange={handleTableChange}
                    pagination={{
                        current: tableParams.page,
                        defaultPageSize: tableParams.size,
                        total: data?.total,
                    }}
                >
                    <Column<Event>
                        title={'Size'}
                        dataIndex={'size_name'}
                        width={screens.xxl ? 'auto' : 200}
                    />
                    <Column<Event>
                        title={"Action"}
                        width={screens.xxl ? 'auto' : 162}
                        dataIndex={'is_active'}
                        render={(_, record) => (
                            <>
                                <Space>
                                    <Tooltip title="Edit">
                                        <Button shape="circle" icon={<EditOutlined />} onClick={() => handleOpenModal(record)} />
                                    </Tooltip>


                                    <Tooltip title="Delete">
                                        <Button shape="circle" loading={isLoadingUpdate} onClick={() => showDeleteConfirm(record)} icon={<DeleteOutlined />} />
                                    </Tooltip>
                                    <Tooltip title="Is Active">
                                        <Switch
                                            defaultChecked={record.is_active}
                                            checked={record.is_active}
                                            loading={isLoadingUpdate}
                                            onChange={(isChecked) => {
                                                mutateUpdate({
                                                    id: record.id,
                                                    flag: "SIZE_MASTER_SET_STATUS",
                                                    status: isChecked,
                                                });
                                                record.is_active = isChecked;
                                            }}
                                        />
                                    </Tooltip>
                                </Space>
                            </>
                        )}
                    />
                </Table>
            </StyledTableWrapper>
        </>

    );
};

